import styled from 'styled-components';
import { breakpoints } from 'styles/breakpoints';
import { EBundlesInternalViewModel } from 'utils/enums';

export const StyledBundleLayout = styled.div<any>`
  &.bundles_layout {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: ${({ marginTop }) => marginTop || '10px'};
    max-width: ${(props) => props.desktopMaxWidth};
    align-items: ${(props) =>
      props.bundlesInternalViewModel === EBundlesInternalViewModel.MAIN_SUB
        ? 'stretch'
        : 'center'};
    gap: ${({ gapX }) => gapX};

    &.spin-x {
      max-width: 400px;
      .bundle {
        max-width: 400px;
      }

      @media (min-width: ${breakpoints.desktop}) {
        max-width: 480px;
        .bundle {
          max-width: 480px;
        }
      }
    }

    &--ios13 {
      gap: unset;

      .bundle {
        margin-bottom: 12px;
        margin-right: 12px;
      }

      &.pipa {
        .bundle {
          margin-bottom: 8px;
          margin-right: 8px;
        }
      }

      &.play-simple {
        .bundle {
          margin-bottom: 18px;
          margin-right: 0;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }

      &.match {
        .bundle {
          margin: 0 6px 12px 6px;
        }
      }

      &.ghost {
        .bundle {
          margin-right: 0;
        }
      }
    }

    &--mobile-linear {
      @media (width < 800px) {
        .bundle {
          margin-right: 0;
        }
      }
    }

    @media (max-width: 600px) {
      &--mobile-linear {
        flex-direction: column;
      }
    }

    .bundle {
      max-width: ${(props) => props.bundleMaxWidth};
      width: 100%;

      &-top-container {
        height: ${(props) =>
          props.bundlesInternalViewModel === EBundlesInternalViewModel.MAIN_SUB
            ? '100%'
            : 'auto'};
      }

      @media (min-width: 1024px) {
        &:hover {
          z-index: 2;
          position: relative;
        }
      }
    }

    &--mobile-multiple-items {
      .bundle {
        width: calc(33.3333% - 16px);
      }

      &.pipa {
        .bundle {
          width: calc(33.3333% - 6px);
        }
      }
    }

    &__six-in-row {
      .bundle {
        width: calc(16.6667% - 16px);
        min-width: 108px;
      }

      @media (width <= ${breakpoints.mobileL}) {
        margin-top: 18px;
      }
    }
  }
`;
